import React from 'react';
import ElencoPresenze from './ElencoPresenze';

interface Props {
  participants: number[];
  currentParticipantId: number;
  connected: boolean;
}

const PresenzeShortlist = (props: Props) => {
  const { participants, currentParticipantId, connected } = props;
  return <section className="shortlist-presence" aria-label="Modifica simultanea">
    <h2><i className="fa fa-users mr-2" aria-hidden="true" />Modifica simultanea</h2>
    {connected ? <>
      <span className="shortlist-presence-count small text-muted">{participants.length} {participants.length === 1 ? 'partecipante connesso' : 'partecipanti connessi'}</span>
      {participants.length ? <ElencoPresenze participants={participants} currentParticipantId={currentParticipantId} />
        : <span className="small text-muted">Nessuna presenza ancora rilevata.</span>}
    </> : <span className="small text-muted">Presenze non disponibili: collaborazione non connessa.</span>}
  </section>;
};

export default PresenzeShortlist;
